<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [cardOptionBtnIcon]="'feather icon-plus'"
                [cardOptionBtn]="false" [title]="'global.overview'|translate">
        <app-grid [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>

<ng-template #actorTemp let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.actor"></span>{{row.actor.username}}
</ng-template>
<ng-template #draftInvoicType let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.draftInvoice"> </span>{{row.draftInvoice.type }}
</ng-template>
<ng-template #approveInvoiceNumber let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.draftInvoice"> </span>{{row.draftInvoice?.approvedInvoiceNumber }}
</ng-template>

<ng-template #modelTooltip let-row="row" let-value="value" let-column="column">
  <span class="tooltip-item" *ngIf="true">
    <span class="tooltipBox">
      {{row.message}}
    </span>
    <span class="desc-place" *ngIf="row.message && row.message.length > 100">
      <span>
        {{row.message}}
      </span>
    </span>
  </span>
</ng-template>
